import React from 'react'
import PropTypes from 'prop-types'
import { connect } from 'react-redux'
import { Route, Routes } from 'react-router-dom'
import Spinner from '../../../src/components/Spinner/Spinner'
import ComcastBilling, { MONTHLY } from '../../lib/ComcastBilling'
import CustomAmountScreen from './CustomAmount'
import DefaultDonationAmounts from './DefaultAmount'
import * as UI from '../../lib/ui'
import TVaultDonationService, {
  APPROVED,
  DECLINED,
} from '../../lib/TVaultDonationService'
import ErrorModal from '../../../src/components/ErrorModal/ErrorModal'
import PBSError from '../../../../shared/PBSError'
import { checkPassportStatus } from '../../actions/userActions'
import { CUSTOM } from './CustomAmount'
import googleAnalytics4 from '../../lib/googleAnalytics'
import { withRouter } from '../../../../shared/components/WithRouter/WithRouter'

export class InAppDonationScreen extends React.Component {
  constructor(props) {
    super(props)
    this.state = {
      sdkModal: false,
      transactionProcessSpinner: false,
      error: null,
    }

    this.comcastBilling = new ComcastBilling()
    this.tvaultDonationService = new TVaultDonationService(
      this.props.station.call_sign
    )
  }
  componentDidMount() {
    UI.setSidePanelVisibility(false)
  }

  componentWillUnmount() {
    if (this.tvaultDonationService) this.tvaultDonationService.clearTimeout()
  }

  executeDonationProcess = async ({
    totalChargeAmount,
    donationFrequency,
    donationType,
  }) => {
    let oat = 'undefined'
    const passportActivationStatus = await checkPassportStatus(
      this.props.station.call_sign
    )
    if (passportActivationStatus === 'PENDING') {
      this.props.router.navigate('/passport-activation', {
        navigatingFromDonation: true,
        stationTitle: this.props.station.short_common_name,
      })
    } else if (passportActivationStatus === 'ACTIVATED') {
      this.props.router.navigate(-1)
    } else {
      try {
        this.setState({
          transactionProcessSpinner: true,
        })

        // eslint-disable-next-line @typescript-eslint/no-unused-vars
        const { consentToken, oat: at } = await this.triggerComcastBillingSDK({
          totalChargeAmount,
          donationType,
          donationFrequency,
        })

        oat = at

        this.setState({
          tvaultSpinner: true,
        })

        const { id: donationCampaignId } = this.props.station.donation_campaign

        this.tvaultDonationService.setDonationFrequency(donationFrequency)
        this.tvaultDonationService.setDonationPayload(
          this.comcastBilling.consentPayload,
          {
            donationCampaignId,
            totalChargeAmount,
            consentToken,
            oat,
          }
        )
        const { donationResponse } =
          await this.tvaultDonationService.triggerProcess()

        const donationStatus =
          this.tvaultDonationService.getDonationResponseStatus(donationResponse)

        if ([APPROVED, DECLINED].includes(donationStatus)) {
          this.setState({
            transactionProcessSpinner: false,
          })
          if (donationStatus === APPROVED) {
            googleAnalytics4.sendCustomEvent(
              'donation_success',
              {
                donation_frequency:
                  donationFrequency === MONTHLY ? 'monthly' : 'one-time',
                donation_amount: `$${totalChargeAmount}/${
                  donationFrequency === MONTHLY ? 'month' : 'one-time'
                }`,
                donation_type: donationType,
                external_key: oat,
              },
              'In App Donation Screen'
            )

            this.tvaultDonationService.configureMvaultId(donationResponse)

            this.props.router.navigate('/passport-activation', {
              state: {
                stationTitle: this.props.station.short_common_name,
                navigatingFromDonation: true,
                customDonationType: donationType === CUSTOM,
              },
            })
          }

          if (donationStatus === DECLINED) {
            const error = new Error('Declined donation.')

            //TODO: Remove this when a better approach is implemented
            error.status = ' '

            const pbsError = new PBSError(error, 'TVAULT_ERROR')
            //TODO: Remove this when a better approach is implemented
            pbsError.textErrorCode =
              this.tvaultDonationService.getDonationDeclinedReason(
                donationResponse
              )

            PBSError.sendSentryError({
              errorString: 'TVault service error',
              errorTitle: 'InAppDonationScreen.ts',
              extraParams: {
                errorCodeNumber: pbsError.errorStatus,
                errorCodeText: error.name,
                errorMessage: error.message,
                userPid: this.props.user.pid,
                partnerID: this.props.device.distributor,
              },
            })

            throw pbsError
          }
        }
      } catch (error) {
        if (error instanceof PBSError) {
          googleAnalytics4.sendCustomEvent(
            'donation_error',
            {
              donation_frequency:
                donationFrequency === MONTHLY ? 'monthly' : 'one-time',
              donation_amount: `$${totalChargeAmount}/${
                donationFrequency === MONTHLY ? 'month' : 'one-time'
              }`,
              donation_type: donationType,
              external_key: oat,
              error_code_id: error.errorStatus,
              error_code_title: error.errorCode,
              error_code_text: error.errorDetail,
            },
            'In App Donation Screen'
          )

          const { errorMessage } = error.parse()
          const buttons = []
          if (error.shouldTryAgainButton) {
            buttons.push({
              label: 'Try again',
              name: 'tryAgainButton',
              onClick: () => {
                this.setState({
                  error: null,
                })
                this.executeDonationProcess({
                  totalChargeAmount,
                  donationFrequency,
                })
              },
            })
          }
          if (error.goBackButton) {
            buttons.push({
              label: 'Go back',
              name: 'goBackButton',
              onClick: () => {
                this.setState({
                  error: null,
                })
              },
            })
          }
          if (error.okButton) {
            buttons.push({
              label: 'OK',
              name: 'goBackButton',
              onClick: () => {
                this.props.router.navigate(-1)
              },
            })
          }
          this.setState({
            error: { ...errorMessage, buttons },
          })
        }
        this.setState({
          transactionProcessSpinner: false,
        })
        console.log('--- ERROR', error) // TODO remove this log
      }
    }
  }

  triggerComcastBillingSDK = async ({
    totalChargeAmount,
    donationType,
    donationFrequency,
  }) => {
    return this.comcastBilling.purchase({
      totalChargeAmount,
      donationType,
      donationFrequency,
    })
  }

  render() {
    const { transactionProcessSpinner: transactionProcessSpinner, error } =
      this.state
    return error ? (
      <ErrorModal
        title={error.errorTitle}
        description={error.errorText}
        error={error.e}
        buttons={error.buttons}
        componentType="errorModal"
        visible={true}
        hideStationLogo={true}
      />
    ) : (
      <div className="donation-container">
        <div className="pending-response-spinner">
          {transactionProcessSpinner && (
            <Spinner visible={transactionProcessSpinner} />
          )}
        </div>
        <Routes>
          <Route
            path="/custom-amount-donation/:frequency"
            element={
              <CustomAmountScreen
                station={this.props.station}
                executeDonationProcess={this.executeDonationProcess}
              />
            }
          />
          <Route
            path="/"
            element={
              <DefaultDonationAmounts
                station={this.props.station}
                executeDonationProcess={this.executeDonationProcess}
              />
            }
          />
        </Routes>
      </div>
    )
  }
}

const mapStateToProps = (state) => {
  return {
    station: state.station,
    user: state.user,
    device: state.device,
  }
}

InAppDonationScreen.propTypes = {
  station: PropTypes.shape({
    short_common_name: PropTypes.string,
    call_sign: PropTypes.string,
    donation_campaign: PropTypes.shape({
      id: PropTypes.string,
      minimum_amount: PropTypes.string,
      minimum_monthly_amount: PropTypes.string,
      monthly_amount_options: PropTypes.array,
      onetime_amount_options: PropTypes.array,
    }),
  }),
  router: PropTypes.shape({
    navigate: PropTypes.func,
  }),
  user: PropTypes.shape({
    pid: PropTypes.string,
  }),
  device: PropTypes.shape({
    distributor: PropTypes.string,
  }),
}

export default connect(
  mapStateToProps,
  null,
  null
)(withRouter(InAppDonationScreen))
